import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Radium } from '../hocs/Radium'

export const Icon = Radium(({ icon, ...props }) => (
  <FontAwesomeIcon icon={icon} {...props} />
))
